import { Box, Button, styled } from "@material-ui/core";
import { Typography } from "../../shared/theme/styles.enum";

export const VerificationContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const VerificationLabel = styled(Box)(({ theme }) => ({
  textAlign: "center",
}));

export const VerificationButton = styled(Button)(({ theme }) => ({
  padding: "10px 34px",
  borderRadius: 8,
  border: `solid 1px ${theme.palette.primary.dark}`,
  fontFamily: Typography.FontFamily2,
  fontSize: Typography.Body,
  fontWeight: 600,
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: theme.palette.text.primary,
}));

export const VerificationResultImage = styled("img")(({ theme }) => ({
  width: "76px",
  height: "76px",
}));
